var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.58301 17.9167H15.4163C16.7971 17.9167 17.9163 16.7975 17.9163 15.4167V4.58337C17.9163 3.20267 16.7971 2.08337 15.4163 2.08337H4.58301C3.2023 2.08337 2.08301 3.20267 2.08301 4.58337V15.4167C2.08301 16.7975 3.2023 17.9167 4.58301 17.9167Z",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.5 17.9167V2.08337",
    stroke: "#6B7280",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.9163 6.66663H2.08301",
    stroke: "#6B7280",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.9163 13.3334H2.08301",
    stroke: "#6B7280",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIcon);
export default __webpack_public_path__ + "static/media/table-icon.5012bc4c627248646a94366bb65f124e.svg";
export { ForwardRef as ReactComponent };